import React from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 43vh;
`;

const StyledTextField = styled(TextField)`
  && {
    width: calc(100% - 50px);
    margin-left: 25px;
  }
`;

const StyledErrorMessage = styled.div`
  && {
    margin-left: 25px;
    margin-bottom: -15px;
    color: #c40a0a;
    font-family: work sans;
    font-weight: 600;
    font-size: 12px;
  }
`;

const styles = () => ({
  root: {
    '&$error': {
      color: "#c40a0a",
      opacity: "100%"
    }
  },
  underline: {
    '&$error:after': {
      borderBottomColor: "#FF0000"
    }
  },
  error: {
  },
  textAreaRoot: {
    width: "100%",
    marginTop: "20px"
  },
  textAreaInput: {
    borderRadius: "4",
    border: "1px solid #ced4da",
    fontSize: "16px",
    width: "525px",
    padding: "10px 12px",
    height: "80px"
  },
  checkbox: {
    fontFamily: "work sans",
    fontSize: "14px"
  },
  dialogTitle: {
    fontFamily: "work sans",
    fontSize: "20px"
  },
  divider: {
    backgroundColor: "lightgrey",
    margin: "10px 0"
  },
  textField: {
    backgroundColor: "#F0F0F0",
    color: "#000000",
    paddingLeft: "10px",
    borderRadius: "4px",
    paddingTop: "30px",
    height: "22px"
  },
  textFieldLabel: {
    zIndex: "99",
    color: "#000000",
    opacity: "54%",
    marginLeft: "10px",
    marginTop: "5px",
    fontSize: "12px"
  }
});

const ShareFormContainer = ({ values, errors, handleOnChange, handleChange, setFieldValue, taskDetails, classes }) => {
  return (
    <StyledContainer>
      {errors.email ? <StyledErrorMessage>{errors.email}</StyledErrorMessage> : null}
      <StyledTextField
        name="email"
        id="email"
        label="Add recipient emails (comma-separated)"
        error={Boolean(errors.email)}
        variant="filled"
        value={values.email}
        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
        InputProps={{
          classes: {
            root: classes.root,
            input: classes.textField,
            error: classes.error,
            underline: classes.underline
          }
        }}
        FormHelperTextProps={{
          classes: {
            root: classes.root,
            error: classes.error
          }
        }}
        InputLabelProps={{
          shrink: false,
          className: classes.textFieldLabel,
          FormLabelClasses: {
            root: classes.root,
            error: classes.error
          }
        }}
      />
      <FormControlLabel
        style={{ width: "90%", marginLeft: "10px" }}
        onChange={(e) => setFieldValue(e.target.name, e.target.checked)}
        value="saveRecipients"
        control={<Checkbox checked={values.saveRecipients} name="saveRecipients" color="primary" />}
        label={<Typography className={classes.checkbox}>{`Save recipients for all reports for ${taskDetails?.deal?.name}`}</Typography>}
      />
      <Divider classes={{ root: classes.divider }} />
      {errors.subject ? <StyledErrorMessage>{errors.subject}</StyledErrorMessage> : null}
      <StyledTextField
        name="subject"
        id="subject"
        label="Subject"
        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
        value={values.subject}
        error={Boolean(errors.subject)}
        InputProps={{
          classes: {
            root: classes.root,
            input: classes.textField,
            error: classes.error,
            underline: classes.underline
          }
        }}
        FormHelperTextProps={{
          classes: {
            root: classes.root,
            error: classes.error
          }
        }}
        InputLabelProps={{
          shrink: false,
          className: classes.textFieldLabel,
          FormLabelClasses: {
            root: classes.root,
            error: classes.error
          }
        }}
      />
      <StyledTextField
        name="message"
        id="bootstrap-input"
        multiline
        rows="4"
        value={values.message}
        onChange={handleChange}
        error={Boolean(errors.message)}
        placeholder="Include a message (optional)"
        InputProps={{
          disableUnderline: true,
          classes: {
            root: classes.textAreaRoot,
            input: classes.textAreaInput
          }
        }}
      />
    </StyledContainer>
  );
};

export default withStyles(styles)(ShareFormContainer);
